module.exports = __webpack_public_path__ + "images/emoji/fork_and_knife.3f340a9d3a9edbf8f500.png";